import I18n from "../../utils/i18n";

const t = (key) => new I18n(window.rails_I18n).t(key);

Dropzone.options.myPrettifiedDropzone = {
	addRemoveLinks: true,
	acceptedFiles: ".jpeg, .jpg, .png, .tif, .heic, .heif",
	maxFiles: 20,
	maxThumbnailFilesize: 5,
	maxFilesize: 5,
	dictDefaultMessage: t('dropzone.drop_image'),
	dictRemoveFile: t('dropzone.remove_image'),
	dictCancelUpload: t('dropzone.cancel_upload'),

	init: function() {
		// jQuery AJAX for HEIC thumbnails
		const convertHeicImage = function(file) {
			const formData = new FormData();
			formData.append('image', file);

			$.ajax({
				url: '/convert_heic_thumbnail',
				type: 'POST',
				data: formData,
				contentType: false,
				processData: false,
				xhrFields: {
					withCredentials: true
				},
				headers: {
					'X-CSRF-Token': $('[name="csrf-token"]').val()
				},
				success: function(data, status, xhr) {
					for (let thumbnailElement of file.previewElement.querySelectorAll("[data-dz-thumbnail]")) {
						thumbnailElement.alt = file.name;
						thumbnailElement.src = data.thumbnail;
					}
				},
				error: function(xhr) {
					console.log('HEIC thumbnail conversion failed');
					// Fallback: HEIC placeholder
					for (let thumbnailElement of file.previewElement.querySelectorAll("[data-dz-thumbnail]")) {
						thumbnailElement.src = '/images/heic-placeholder.png';
					}
				}
			});
		};

		this.on("success", function(file) {
			if (!file.type.startsWith("image/")) {
				convertHeicImage(file)
			}
		});

		this.on("error", (file, message) => {
			if (file.previewElement) {
				file.previewElement.classList.add("dz-error");
				if (typeof message !== "string" && message.error) {
					message = message.error;
				}
				for (let node of file.previewElement.querySelectorAll(
					"[data-dz-errormessage]"
				)) {
					if (file.xhr && file.xhr.status == "304") {
						node.textContent = t('dropzone.number_of_images_exceeded_limit');
					} else {
						node.textContent = message;
					}

				}
			}
		});
		this.on("removedfile", file => {
			const responseData = file.xhr.responseText;
			const jsonData = JSON.parse(responseData);
			let myData = {image_key: jsonData.imageKey};
			let myPath = window.location.pathname;
			let myUrl;
			if (myPath.includes("/listings/new")) {
				myUrl = "/listings/remove_photos_new";
			} else if (myPath.includes("/gallery")){
				myUrl = "/gallery/remove_photos"
			} else if (myPath.includes("/support")){
				myUrl = "/support/remove_photos"
			} else {
				myUrl = myPath + "/remove_photos_show";
			}
			$.ajax({
				type: "DELETE",
				url: myUrl,
				data: myData,
			}).done(function() {
				// alert('Image was successfully removed.')
			}).fail(function() {
				alert('An error occured in removal process.');
			}).always(function() {
				// console.log('Complete');
			})
		});
	}
}
